<template>
    <div class="content container-fluid">
        <!-- Begin: Popover for Filter -->
        <popover name="popName" :pointer="false" style="width: 30em; margin-left: -5em">
            <multiselect v-model="searchColFilter.tranName" :options="colFilter.tranNameColFilter" :multiple="true">
            </multiselect>
        </popover>
        <popover name="popStatus" :pointer="false" style="width: 30em; margin-left: -5em">
            <multiselect v-model="searchColFilter.tranStatus" :options="colFilter.tranStatusColFilter" :multiple="true">
            </multiselect>
        </popover>
        <!-- End: Popover for Filter -->

        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Applicable Leave Types</h3>
                </div>
                <div class="col-auto float-right ml-auto">
                    <button class="btn add-btn" @click="add">
                        <i class="fa fa-plus"></i>New Leave Type
                    </button>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Filter -->
        <div class="row align-items-center mt-2">
            <div class="col-md-2 fit-content">Company</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="company">
                    <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                        {{ item.CompanyName }}
                    </option>
                </select>
            </div>
        </div>
        <!-- /Filter -->

        <!-- Pagination -->
        <div class="row mt-4">
            <div class="col-md-6">
                Show
                <select class="custom-select" v-model="paging.SizePerPage" style="width: 5em">
                    <option v-for="item in paging.Sizes" v-bind:key="item" v-bind:value="item">
                        {{ item }}
                    </option>
                </select>
                entries
            </div>
        </div>
        <!-- /Pagination -->

        <!-- Table List -->
        <div class="row mt-2">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <form id="saveForm" @submit.prevent="save"></form>
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th class="action-column">Action</th>
                                <th class="name-column">
                                    <i class="fa fa-filter" v-popover:popName v-if="colFilter" :style="[
                                        searchColFilter.tranName.length > 0
                                            ? { color: 'orange' }
                                            : { color: 'white' },
                                    ]"></i>
                                    <button class="btn p-0" @click="setSortBy('name')">
                                        Leave Code / Leave Name
                                        <span class="tableHeaderSortIcon">
                                            <i class="fa fa-long-arrow-up ml-3" :style="[
                                                paging.SortBy === 'name'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i>
                                            <i class="fa fa-long-arrow-down" :style="[
                                                paging.SortBy === 'name_desc'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i></span>
                                    </button>
                                </th>
                                <th class="status-column">
                                    <i class="fa fa-filter" v-popover:popStatus v-if="colFilter" :style="[
                                        searchColFilter.tranStatus.length > 0
                                            ? { color: 'orange' }
                                            : { color: 'white' },
                                    ]"></i>
                                    <button class="btn p-0" @click="setSortBy('status')">
                                        Status
                                        <span class="tableHeaderSortIcon">
                                            <i class="fa fa-long-arrow-up ml-3" :style="[
                                                paging.SortBy === 'status'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i>
                                            <i class="fa fa-long-arrow-down" :style="[
                                                paging.SortBy === 'status_desc'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i></span>
                                    </button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="showAddMode" class="table-info">
                                <td class="action-column">
                                    <button type="submit" class="btn" title="Save" form="saveForm">
                                        <i class="fa fa-save"></i>
                                    </button>
                                    <button type="button" class="btn" title="Cancel" @click="cancel">
                                        <i class="fa fa-window-close-o"></i>
                                    </button>
                                </td>
                                <td class="name-column">
                                    <select class="form-control" v-model="formData.leaveCode" form="saveForm" required>
                                        <option value="">-- Please Select --</option>
                                        <option v-for="leaveName in leaveNames" :key="leaveName.Code"
                                            :value="leaveName.Code">
                                            {{ leaveName.Code }} / {{ leaveName.Name }}
                                        </option>
                                    </select>
                                </td>
                                <td class="status-column">
                                    <select class="form-control" v-model="formData.status" form="saveForm" required>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </td>
                            </tr>
                            <tr v-for="item in leaveTypes" :key="item.Id">
                                <template v-if="formData.id !== item.Id">
                                    <td class="action-column">
                                        <button class="btn mt-2" title="Edit" @click="edit(item)">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button class="btn mt-2" title="Delete" @click="remove(item.Id)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                    <td class="name-column">{{ item.LeaveName }}</td>
                                    <td class="status-column">{{ item.Status }}</td>
                                </template>
                                <template v-else>
                                    <td class="action-column table-info">
                                        <button type="submit" class="btn" title="Save" form="saveForm">
                                            <i class="fa fa-save"></i>
                                        </button>
                                        <button type="button" class="btn" title="Cancel" @click="cancel">
                                            <i class="fa fa-window-close-o"></i>
                                        </button>
                                    </td>
                                    <td class="name-column table-info">
                                        <select class="form-control" v-model="formData.leaveCode" form="saveForm"
                                            required>
                                            <option value="">-- Please Select --</option>
                                            <option v-for="leaveName in leaveNames" :key="leaveName.Code"
                                                :value="leaveName.Code">
                                                {{ leaveName.Code }} / {{ leaveName.Name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="status-column table-info">
                                        <select class="form-control" v-model="formData.status" form="saveForm" required>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </select>
                                    </td>
                                </template>
                            </tr>
                            <tr v-if="leaveTypes && !leaveTypes.length">
                                <td colspan="3" class="text-center">{{ noRecordText }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table List -->

        <!--Pagination -->
        <div class="row mb-4" v-if="leaveTypes && leaveTypes.length">
            <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
                Showing
                {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
                to
                {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    leaveTypes.length
                }}
                of {{ totalRecords }} entries
            </div>

            <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
                <div class="navbar justify-content-end">
                    <button v-on:click="first()" v-if="paging.CurrentPage != 1" class="btn btn-white">
                        First
                    </button>
                    <button v-on:click="prev()" class="btn btn-white ml-1 mr-3" v-if="paging.CurrentPage > 1">
                        Prev
                    </button>
                    Page
                    <input class="form-control form-control-sm mx-1" type="number" step="1" min="1"
                        :max="paging.TotalPage" v-model="paging.CurrentPage" @change="onCurrentPageChange($event)"
                        style="width: 4rem" />

                    <span>of {{ paging.TotalPage }}</span>
                    <button v-on:click="next()" class="btn btn-white ml-3 mr-1"
                        v-if="paging.CurrentPage < paging.TotalPage">
                        Next
                    </button>
                    <button v-on:click="last()" v-if="paging.CurrentPage != paging.TotalPage" class="btn btn-white">
                        Last
                    </button>
                </div>
            </div>
        </div>
        <!--/Pagination -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            company: "",
            companies: [],
            leaveTypes: null,
            showAddMode: false,
            noRecordText: config.NO_RECORD_TEXT,
            formData: {
                id: "",
                leaveCode: "",
                status: "Active",
            },
            leaveNames: [],
            //for pagination
            searchColFilter: {
                tranName: [],
                tranStatus: [],
            },
            colFilter: {},
            paging: {
                Search: "",
                CurrentPage: 1,
                TotalPage: "",
                SizePerPage: 100,
                Sizes: [5, 10, 20, 100],
                SortBy: "",
            },
            totalRecords: "",
        };
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        searchFilter() {
            return [
                { name: "tranName", val: this.searchColFilter.tranName },
                { name: "tranStatus", val: this.searchColFilter.tranStatus },
            ];
        },
    },

    watch: {
        "searchColFilter.tranName": function (val, oldVal) {
            this.getLeaveTypes();
        },
        "searchColFilter.tranStatus": function (val, oldVal) {
            this.getLeaveTypes();
        },
        "paging.SizePerPage": function (val, oldVal) {
            this.paging.CurrentPage = 1;
            this.getLeaveTypes();
        },
        "paging.CurrentPage": function (val, oldVal) {
            if (val > this.paging.TotalPage) {
                this.paging.CurrentPage = this.paging.TotalPage;
            }
        },
        company(val) {
            this.resetForm();
            this.showAddMode = false;
            this.getLeaveNames();
            this.getLeaveTypes();
        },
    },

    methods: {
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getLeaveNames() {
            let param = {
                Token: this.token,
                Company: this.company,
            };
            this.$store.state.isLoading = true;
            API.getLeaveNames(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.leaveNames = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getLeaveTypes() {
            let param = {
                Token: this.token,
                Search: this.paging.Search,
                CurrentPage: this.paging.CurrentPage,
                TotalPage: this.paging.TotalPage,
                SizePerPage: this.paging.SizePerPage,
                SortBy: this.paging.SortBy,
                searchFilter: this.searchFilter,
                Company: this.company,
            };
            this.$store.state.isLoading = true;
            API.getApplicableLeaveTypes(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.leaveTypes = response.data.record;
                        this.totalRecords = response.data.total;
                        this.paging.TotalPage = response.data.pageCount;
                        this.colFilter = response.data.colFilter;
                        if (this.paging.CurrentPage > this.paging.TotalPage) {
                            this.paging.CurrentPage = 1;
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },

        //action
        resetForm() {
            this.formData = {
                id: "",
                leaveCode: "",
                status: "Active",
            };
        },
        add() {
            this.showAddMode = true;
            this.resetForm();
        },
        edit(payload) {
            this.showAddMode = false;
            this.resetForm();
            this.formData.id = payload.Id;
            this.formData.leaveCode = payload.LeaveCode;
            this.formData.status = payload.Status;
        },
        cancel() {
            this.showAddMode = false;
            this.resetForm();
            this.getLeaveTypes();
        },
        remove(id) {
            let param = {
                Token: this.token,
                Id: id,
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to delete the record?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willDelete) => {
                if (willDelete) {
                    this.$store.state.isLoading = true;
                    API.deleteApplicableLeaveType(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.cancel();
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },
        save() {
            let param = {
                Token: this.token,
                Id: this.formData.id,
                LeaveCode: this.formData.leaveCode,
                Status: this.formData.status,
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to save the record?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveApplicableLeaveType(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.cancel();
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },

        //pagination
        onCurrentPageChange(event) {
            let currentPage = event.target.value;
            if (currentPage < 1) {
                currentPage = 1;
            }
            this.paging.CurrentPage = parseInt(currentPage);
            this.getLeaveTypes();
        },
        first() {
            this.paging.CurrentPage = 1;
            this.getLeaveTypes();
        },
        prev() {
            this.paging.CurrentPage -= 1;
            this.getLeaveTypes();
        },
        next() {
            this.paging.CurrentPage += 1;
            this.getLeaveTypes();
        },
        last() {
            this.paging.CurrentPage = this.paging.TotalPage;
            this.getLeaveTypes();
        },
        setSortBy(payload) {
            switch (payload) {
                case "name":
                    if (this.paging.SortBy === "name") {
                        this.paging.SortBy = "name_desc";
                    } else if (this.paging.SortBy === "name_desc") {
                        this.paging.SortBy = "name";
                    } else {
                        this.paging.SortBy = "name";
                    }
                    break;
                case "status":
                    if (this.paging.SortBy === "status") {
                        this.paging.SortBy = "status_desc";
                    } else if (this.paging.SortBy === "status_desc") {
                        this.paging.SortBy = "status";
                    } else {
                        this.paging.SortBy = "status";
                    }
                    break;
            }
            this.getLeaveTypes();
        },
    },

    mounted() {
        this.getCompanies();
        this.company = config.DEFAULT_COMPANY;
    },
    created() {
        if (this.role != "admin")
            this.$router.replace({ name: "home" });
    },
};
</script>

<style scoped>
.action-column {
    width: 10%;
}

.name-column {
    width: 60%;
}

.fit-content {
    max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/Attendance/ApplicableLeaveType.vue